import React, { useState, useEffect } from 'react'
import { Box, TextInput, SimpleGrid, Flex, Group, Button, Select, NumberInput, Textarea, Text, Avatar, Loader, Tabs, Paper, Image, ScrollArea, Divider, Grid, Input, Center } from '@mantine/core'
import { quantityUnit, typeQuoteList, packageTypeList, orderTerms, dimensionUnit, bulkUnitList } from '../../../helper/master-unit'
import { Dropzone } from '@mantine/dropzone'
import { validation } from '../../../plugins/validation'
import { getAllCurrencyList } from '../../../services/currency'
import { getListUsers } from '../../../services/users'
import { getAllCountryList } from '../../../services/location'
import { getAllProductsList } from '../../../services/products'
import { getAllSupplierList } from '../../../services/supplier'
import { getAllSourcingRequestList } from '../../../services/sourcing-request'
import { addRequestQuote, addRequestQuoteBulkPrice, deleteRequestQuoteBulkPrice, updateRequestQuote, updateRequestQuoteBulkPrice } from '../../../services/request-quote'
import LoadingData from '../../ui/LoadingData'
import { IconCheck, IconTrash, IconPhotoPlus } from '@tabler/icons-react'
import NoImage from '../../../assets/img/images/no-images.png'
import { notificationSuccess, notificationError } from '../../ui/Notifications'
import { useDebouncedCallback } from '@mantine/hooks'
import { IconPlus } from '@tabler/icons-react'
import { useViewportSize } from '@mantine/hooks'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { 
  ClassicEditor, 
  Bold, 
  Essentials, 
  Italic, 
  Mention, 
  Paragraph, 
  Undo, 
  Font, 
  Heading,
  List,
  Alignment,
  Link,
  PasteFromOffice
} from 'ckeditor5'

const defaultVal = {
  supplier_id: null,
  user_id: null,
  product_id: null,
  product_request_id: null,
  product_name: '',
  quantity_unit: 'pcs',
  weight: 0,
  volume: 0,
  origin_country_id: null,
  destination_country_id: null,
  description: '',
  quote_type: 'PROCUREMENT',
  original_source_url: '',
  sales_by: null,
  agent_id: null,
  package_type: 'regular',
  terms: 'FOB',
  currency: 'IDR',
  landed_cost_currency: 'IDR',
  is_catalog: false,
  deletedIdVariants: [],
  variants: [
    {
      request_quote_id: null,
      name: '',
      option: '',
      supplier_price: 0,
      landed_cost_currency: 0,
      supplier_currency: 'IDR',
      description: '',
      weight: 0,
      height: 0,
      width: 0,
      length: 0,
      volume: 0,
      dimension_unit: 'cm',
      bulk_unit: 'crt',
      bulk_qty: 0,
      bulk_qty_per_unit: null,
      qty: 0,
      variant_specification: '',
      image: null,
      recent_variants: []
    }
  ]
}

const formValidation = {
  product_name: {
    isError: false,
    message: ''
  },
  original_source_url: {
    isError: false,
    message: ''
  },
  quantity_unit: {
    isError: false,
    message: ''
  },
  currency: {
    isError: false,
    message: ''
  },
  landed_cost_currency: {
    isError: false,
    message: ''
  },
  package_type: {
    isError: false,
    message: ''
  },
  weight: {
    isError: false,
    message: ''
  },
  volume: {
    isError: false,
    message: ''
  },
  origin_country_id: {
    isError: false,
    message: ''
  },
  destination_country_id: {
    isError: false,
    message: ''
  },
  user_id: {
    isError: false,
    message: ''
  },
  terms: {
    isError: false,
    message: ''
  },
}

const variantValidation = {
  name: {
    isError: false,
    message: ''
  },
  option: {
    isError: false,
    message: ''
  },
  qty: {
    isError: false,
    message: ''
  },
  supplier_price: {
    isError: false,
    message: ''
  },
  dimension_unit: {
    isError: false,
    message: ''
  },
  weight: {
    isError: false,
    message: ''
  },
  height: {
    isError: false,
    message: ''
  },
  width: {
    isError: false,
    message: ''
  },
  length: {
    isError: false,
    message: ''
  },
  bulk_unit: {
    isError: false,
    message: ''
  },
  bulk_qty: {
    isError: false,
    message: ''
  },
  bulk_qty_per_unit: {
    isError: false,
    message: ''
  },
}



const FormProductQuote = ({ dataProductQuote, onCloseModal, reloadList }) => {
  const { width } = useViewportSize()
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [validationVariant, setValidationVariant] = useState(variantValidation)
  const [loadingForm, setLoadingForm] = useState(false)
  const [currencyList, setCurrencyList] = useState([])
  const [originCountryList, setOriginCountryList] = useState([])
  const [destinationCountryList, setDestinationCountryList] = useState([])
  const [productList, setProductList] = useState([])
  const [userList, setUserList] = useState([])
  const [agentList, setAgentList] = useState([])
  const [salesList, setSalesList] = useState([])
  const [supplierList, setSupplierList] = useState([])
  const [sourcingRequestList, setSourcingRequestList] = useState([])
  const [loadingData, setLoadingData] = useState(true)
  const [loadingUser, setLoadingUser] = useState(true)
  const [loadingAgent, setLoadingAgent] = useState(true)
  const [loadingSales, setLoadingSales] = useState(true)
  const [loadingProduct, setLoadingProduct] = useState(true)
  const [loadingSupplier, setLoadingSupplier] = useState(true)
  const [loadingOriginCountry, setLoadingOriginCountry] = useState(true)
  const [loadingDestinationCountry, setLoadingDestinationCountry] = useState(true)
  const [loadingSourcingRequest, setLoadingSourcingRequest] = useState(true)
  const [searchUser, setSearchUser] = useState('')
  const [searchAgent, setSearchAgent] = useState('')
  const [searchSales, setSearchSales] = useState('')
  const [searchSupplier, setSearchSupplier] = useState('')
  const [searchOriginCountry, setSearchOriginCountry] = useState('')
  const [searchDestinationCountry, setSearchDestinationCountry] = useState('')
  const [searchProduct, setSearchProduct] = useState('')
  const [searchSourcingRequest, setSearchSourcingRequest] = useState('')
  const [selectedTab, setSelectedTab] = useState('form')
  const [selectedIndexVariant, setSelectedIndexVariant] = useState(`0`)
  const [isLoaded, setIsLoaded] = useState(false)

  const configEditor = {
    plugins:[
      Bold,
      Essentials,
      Italic,
      Mention,
      Paragraph,
      Undo,
      Font,
      Heading,
      List,
      Alignment,
      Link,
      PasteFromOffice
    ],
    alignment: {
      options: [ 'left', 'right' ]
    },
    fontSize: {
      options: [
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22
      ],
      supportAllValues: true
    },
    list: {
      properties: {
        styles: true,
        startIndex: true,
        reversed: true
      }
    },
    link: {
      decorators: {
        addTargetToExternalLinks: {
          mode: 'automatic',
          callback: url => /^(https?:)?\/\//.test( url ),
          attributes: {
              target: '_blank',
              rel: 'noopener noreferrer'
          }
        }
      }
    }, 
    toolbar: {
      items: [
        'undo', 'redo',
        '|',
        'heading',
        '|',
        'fontSize', 'Bold', 'Italic', 'alignment',
        '|',
        'link',
        '|',
        'bulletedList', 'numberedList',
        '|',
      ],
      shouldNotGroupWhenFull: true
    },
    initialData: `${formData.description}`
  }

  const validDataURL = (str) => {
    const pattern = new RegExp('^(https?:\\/\\/)?'+
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+
      '((\\d{1,3}\\.){3}\\d{1,3}))'+
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+
      '(\\?[;&a-z\\d%_.~+=-]*)?'+
      '(\\#[-a-z\\d_]*)?$','i')
    return !!pattern.test(str)
  }

  const submitRequestQuote = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    setValidationVariant(variantValidation)
    let methodFunction = null
    let titleMessageSuccess = ''
    let captionMessageSuccess = ''
    let titleMessageError = ''
    let captionMessageError = ''
    let payload = {}
    let validateForm = {}
    
    validateForm = {
      product_name: form.product_name,
      original_source_url: form.original_source_url,
      quantity_unit: form.quantity_unit,
      currency: form.currency,
      landed_cost_currency: form.landed_cost_currency,
      package_type: form.package_type,
      weight: `${form.weight}`,
      volume: `${form.volume}`,
      origin_country_id: form.origin_country_id !== null ? `${form.origin_country_id}` : null,
      destination_country_id: form.destination_country_id !== null ? `${form.destination_country_id}` : null,
      user_id: form.user_id !== null ? `${form.user_id}` : null,
      terms: form.terms
    }
    const isErrorForm = validation(validateForm, setValidationForm)
    if (isErrorForm) {
      setSelectedTab('form')
      notificationError('Submit Product Quote Error', 'Check recheck your form')
      setLoadingForm(false)
      return
    }
    const dataVariant = form.variants
    let validateVariant = {}
    for (let i = 0; i < dataVariant.length; i++) {
      if (form.package_type === 'regular') {
        validateVariant = {
          name: dataVariant[i].name,
          option: dataVariant[i].option,
          qty: `${dataVariant[i].qty}`,
          supplier_price: `${dataVariant[i].supplier_price}`,
          weight: `${dataVariant[i].weight}`,
          height: `${dataVariant[i].height}`,
          width: `${dataVariant[i].width}`,
          length: `${dataVariant[i].length}`,
          dimension_unit: dataVariant[i].dimension_unit
        }
        delete validationVariant.bulk_unit
        delete validationVariant.bulk_qty
        delete validationVariant.bulk_qty_per_unit
      } else {
        validateVariant = {
          name: dataVariant[i].name,
          option: dataVariant[i].option,
          qty: `${dataVariant[i].qty}`,
          supplier_price: `${dataVariant[i].supplier_price}`,
          weight: `${dataVariant[i].weight}`,
          height: `${dataVariant[i].height}`,
          width: `${dataVariant[i].width}`,
          length: `${dataVariant[i].length}`,
          dimension_unit: dataVariant[i].dimension_unit,
          bulk_unit: dataVariant[i].bulk_unit,
          bulk_qty: `${dataVariant[i].bulk_qty}`,
          bulk_qty_per_unit: `${dataVariant[i].bulk_qty_per_unit}`
        }
      }
    }

    const isErrorVariant = validation(validateVariant, setValidationVariant)
    if (isErrorVariant) {
      setSelectedTab('variants')
      notificationError('Submit Product Quote Error', 'Check recheck your form variant')
      setLoadingForm(false)
      return
    }
    if (dataProductQuote !== null) {
      payload = {
        supplier_id: form.supplier_id !== null ? Number(form.supplier_id) : null,
        user_id: form.user_id !== null ? Number(form.user_id) : null,
        product_id: form.product_id !== null ? Number(form.product_id) : null,
        product_request_id: form.product_request_id !== null ? Number(form.product_request_id) : null,
        product_name: form.product_name,
        quantity_unit: form.quantity_unit,
        weight: form.weight,
        volume: form.volume,
        origin_country_id: form.origin_country_id !== null ? Number(form.origin_country_id) : null,
        destination_country_id: form.destination_country_id !== null ? Number(form.destination_country_id) : null,
        description: form.description,
        quote_type: form.quote_type.toUpperCase(),
        original_source_url: form.original_source_url,
        sales_by: form.sales_by !== null ? Number(form.sales_by) : null,
        agent_id: form.agent_id !== null ? Number(form.agent_id) : null,
        package_type: form.package_type,
        terms: form.terms,
      }
      methodFunction = updateRequestQuote(form.id, payload)
      titleMessageSuccess = 'Update Product Quote Successfully'
      captionMessageSuccess = 'You have been updated product quote'
      titleMessageError = 'Update Product Quote Error'
    } else {
      const mappingVariantQuote = form.variants.map((val) => {
        const remapVariant = {
          landed_cost_currency: form.landed_cost_currency,
          supplier_currency: form.currency,
          name: val.name,
          option: val.option,
          supplier_price: val.supplier_price,
          qty: val.qty,
          description: val.description,
          weight: val.weight,
          height: val.height,
          width: val.width,
          length: val.length,
          volume: val.volume,
          dimension_unit: val.dimension_unit,
          bulk_unit: form.package_type !== 'regular' ? val.bulk_unit : null,
          bulk_qty: form.package_type !== 'regular' ? val.bulk_qty : null,
          bulk_qty_per_unit: form.package_type !== 'regular' ? val.bulk_qty_per_unit : null,
        }
        if (val.image !== null) {
          remapVariant.image_encoded = val.image
        }
        return remapVariant
      })
      payload = {
        supplier_id: form.supplier_id !== null ? Number(form.supplier_id) : null,
        user_id: form.user_id !== null ? Number(form.user_id) : null,
        product_id: form.product_id !== null ? Number(form.product_id) : null,
        product_request_id: form.product_request_id !== null ? Number(form.product_request_id) : null,
        product_name: form.product_name,
        quantity_unit: form.quantity_unit,
        weight: form.weight,
        weight_unit: 'kg',
        volume: form.volume,
        volume_unit: 'cbm',
        origin_country_id: form.origin_country_id !== null ? Number(form.origin_country_id) : null,
        destination_country_id: form.destination_country_id !== null ? Number(form.destination_country_id) : null,
        description: form.description,
        quote_type: form.quote_type.toUpperCase(),
        original_source_url: form.original_source_url,
        sales_by: form.sales_by !== null ? Number(form.sales_by) : null,
        agent_id: form.agent_id !== null ? Number(form.agent_id) : null,
        package_type: form.package_type,
        terms: form.terms,
        variations: mappingVariantQuote,
        is_catalog: false,
      }
      
      methodFunction = addRequestQuote(payload)
      titleMessageSuccess = 'Add Product Quote Successfully'
      captionMessageSuccess = 'You have been added new product quote'
      titleMessageError = 'Add Product Quote Error'
    }
    try {
      const response = await methodFunction
      if (response.success) {
        let createVariantBulkPrice = null
        let updateVariantBulkPrice = null
        
        if (dataProductQuote !== null) {
          const findDataCreateVariant = form.variants.filter(val => val.request_quote_id === null)
          const findDataRecentVariant = form.variants.filter(val => val.request_quote_id === form.id)
          if (findDataCreateVariant.length > 0) {
            createVariantBulkPrice = await handleCreateBulkPriceVariants(form, findDataCreateVariant)
          }
          if (findDataRecentVariant.length > 0) {
            updateVariantBulkPrice = await handleUpdateBulkPriceVariants(form)
          }
          if(form.deletedIdVariants.length > 0) {
            await handleDeleteBulkPriceVariants(form)
          }
          if (createVariantBulkPrice !== null ? createVariantBulkPrice.success : '' || updateVariantBulkPrice !== null ? updateVariantBulkPrice.success : '') {
            onCloseModalForm()
            reloadList()
            notificationSuccess(titleMessageSuccess, captionMessageSuccess)
          }
        } else {
          onCloseModalForm()
          reloadList()
          notificationSuccess(titleMessageSuccess, captionMessageSuccess)
        }
        
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Please recheck your form'
      notificationError(titleMessageError, captionMessageError)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleCreateBulkPriceVariants = async (dataQuote, dataNewVariant) => {
    const dataVariant = dataNewVariant
    const remapCreateVariants = dataVariant.map((val) => {
      const recentDetail = dataQuote.detail_price
      return recentDetail.map((detail) => {
        const remap = {
          id: detail.id,
          specification: {
            name: val.name,
            option: val.option
          },
          qty: val.qty,
          supplier_price: val.supplier_price,
          landed_cost_currency: dataQuote.landed_cost_currency,
          supplier_currency: dataQuote.currency,
          landed_cost: detail.landed_cost,
          shipping_type: detail.shipping_type,
          description: val.description,
          weight: val.weight,
          height: val.height,
          width: val.width,
          length: val.length,
          volume: 0,
          dimension_unit: val.dimension_unit,
          bulk_unit: dataQuote.package_type !== 'regular' ? val.bulk_unit : null,
          bulk_qty: dataQuote.package_type !== 'regular' ? val.bulk_qty : null,
          bulk_qty_per_unit: dataQuote.package_type !== 'regular' ? val.bulk_qty_per_unit : null,
        }
        if (val.image !== null && !validDataURL(val.image)) {
          remap.image_encoded = val.image
        }
        return remap
      })
    })
    const payload = {
      prices: remapCreateVariants.flatMap((val) => val)
    }
    try {
      const response = await addRequestQuoteBulkPrice(dataQuote.id, payload)
      return response
    } catch (error) {
      console.log(error)
    }
  }

  const handleUpdateBulkPriceVariants = async (dataQuote) => {
    const dataVariant = dataQuote.variants
    const remapUpdateVariants = dataVariant.map((val) => {
      const recentVariant = val.recent_variants
      return recentVariant.map((detail) => {
        const remap = {
          id: detail.id,
          specification: {
            name: val.name,
            option: val.option
          },
          qty: val.qty,
          supplier_price: val.supplier_price,
          landed_cost_currency: dataQuote.landed_cost_currency,
          supplier_currency: dataQuote.currency,
          landed_cost: detail.landed_cost,
          shipping_type: detail.shipping_type,
          description: val.description,
          weight: val.weight,
          height: val.height,
          width: val.width,
          length: val.length,
          volume: detail.volume,
          dimension_unit: val.dimension_unit,
          bulk_unit: dataQuote.package_type !== 'regular' ? val.bulk_unit : null,
          bulk_qty: dataQuote.package_type !== 'regular' ? val.bulk_qty : null,
          bulk_qty_per_unit: dataQuote.package_type !== 'regular' ? val.bulk_qty_per_unit : null,
        }
        if (val.image !== null && !validDataURL(val.image)) {
          remap.image_encoded = val.image
        }
        return remap
      })
    })
    const payload = {
      prices: remapUpdateVariants.flatMap((val) => val)
    }
    try {
      const response = await updateRequestQuoteBulkPrice(dataQuote.id, payload)
      return response
    } catch (error) {
      console.log(error)
    }
  }

  const handleDeleteBulkPriceVariants = async (dataQuote) => {
    const payload = { ids: [...dataQuote.deletedIdVariants] }
    try {
      const response = await deleteRequestQuoteBulkPrice(dataQuote.id, payload)
      return response
    } catch (error) {
      console.log(error)
    }
  }


  const handleGetCurrenciesList = async () => {
    setLoadingData(true)
    const params = {
      groupBy: 'currency_code'
    }
    try {
      const response = await getAllCurrencyList(params)
      const dataCurrencies = response.data
      const remapCurrency = dataCurrencies.map((val) => {
        return val.attributes.currency_code
      })
      setCurrencyList(remapCurrency)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingData(false)
    }
  }

  const handleGetListUsers = useDebouncedCallback(async (userId) => {
    setLoadingUser(true)
    const parameter = {
      'filter[id][is]': userId,
      'filter[name][like]': searchUser,
      'fields[user]': 'id,name,email,active',
      'page[num]': 1,
      'page[limit]': 8,
      'sort': '-created_at',
      'active': true
    }
    try {
      const response = await getListUsers(parameter)
      const dataUser = response.data.data
      const remapDataUser = dataUser.map((val) => {
        return {
          label: val.attributes.name,
          value: `${val.attributes.id}`,
          email: val.attributes.email
        }
      })
      setUserList(remapDataUser)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingUser(false)
    }
  }, 300)

  const handleGetListAgent = useDebouncedCallback(async (userId) => {
    setLoadingAgent(true)
    const parameter = {
      'filter[id][is]': userId,
      'filter[name][like]': searchAgent,
      'fields[user]': 'id,name,email,active',
      'page[num]': 1,
      'page[limit]': 8,
      'sort': '-created_at',
      'active': true,
      'filter[is_agent][is]': 1,

    }
    try {
      const response = await getListUsers(parameter)
      const dataUser = response.data.data
      const remapDataUser = dataUser.map((val) => {
        return {
          label: val.attributes.name,
          value: `${val.attributes.id}`,
          email: val.attributes.email
        }
      })
      setAgentList(remapDataUser)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingAgent(false)
    }
  }, 300)

  const handleGetListSales = useDebouncedCallback(async (userId) => {
    setLoadingSales(true)
    const parameter = {
      'filter[id][is]': userId,
      'filter[name][like]': searchSales,
      'fields[user]': 'id,name,email,active',
      'page[num]': 1,
      'page[limit]': 8,
      'sort': '-created_at',
      'active': true
    }
    try {
      const response = await getListUsers(parameter)
      const dataUser = response.data.data
      const remapDataUser = dataUser.map((val) => {
        return {
          label: val.attributes.name,
          value: `${val.attributes.id}`,
          email: val.attributes.email
        }
      })
      setSalesList(remapDataUser)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingSales(false)
    }
  }, 300)

  const handleGetListOriginCountry = useDebouncedCallback(async (originCountryId) => {
    setLoadingOriginCountry(true)
    const parameter = {
      'filter[id][is]': originCountryId,
      'filter[name][like]': searchOriginCountry,
      'page[num]': 1,
      'page[limit]': 15,
      'fields[country]': 'name,iso_code_2,currency',
    }
    try {
      const response = await getAllCountryList(parameter)
      const dataCountry = response.data
      const remapDataCountry = dataCountry.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setOriginCountryList(remapDataCountry)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingOriginCountry(false)
    }
  }, 300)

  const handleGetListDestinationCountry = useDebouncedCallback(async (destinationCountryId) => {
    setLoadingDestinationCountry(true)
    const parameter = {
      'filter[id][is]': destinationCountryId,
      'filter[name][like]': searchDestinationCountry,
      'page[num]': 1,
      'page[limit]': 15,
      'fields[country]': 'name,iso_code_2,currency',
    }
    try {
      const response = await getAllCountryList(parameter)
      const dataCountry = response.data
      const remapDataCountry = dataCountry.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setDestinationCountryList(remapDataCountry)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingDestinationCountry(false)
    }
  }, 300)

  const handleGetListProduct = useDebouncedCallback(async (productId) => {
    setLoadingProduct(true)
    const parameter = {
      'filter[id][is]': productId,
      'filter[title][like]': searchProduct,
      'page[num]': 1,
      'page[limit]': 15,
    }
    try {
      const response = await getAllProductsList(parameter)
      const responseProduct = response.data
      const remapDataProduct = responseProduct.map((val) => {
        return {
          label: val.attributes.title,
          value: `${val.attributes.id}`,
          image: val.attributes.image
        }
      })
      
      setProductList(remapDataProduct)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingProduct(false)
    }
  }, 300)

  const handleGetListSupplier = useDebouncedCallback(async (supplierId) => {
    setLoadingSupplier(true)
    const parameter = {
      'filter[id][is]': supplierId,
      'filter[name][like]': searchSupplier,
      'page[num]': 1,
      'page[limit]': 10,
      'fields[supplier]': 'name'
    }

    try {
      const response = await getAllSupplierList(parameter)
      const dataSuppliers = response.data
      const remapDataSuppliers = dataSuppliers.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      
      setSupplierList(remapDataSuppliers)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingSupplier(false)
    }
  }, 300)

  const handleGetListSourcingRequest = useDebouncedCallback(async (sourcingId) => {
    setLoadingSourcingRequest(true)
    const parameter = {
      'filter[id][is]': sourcingId,
      'filter[title][like]': searchSourcingRequest,
      'page[num]': 1,
      'page[limit]': 10,
      'fields[country]': 'title,request_number',
      'fields[image]': 'source',
      'include': 'images'
    }

    try {
      const response = await getAllSourcingRequestList(parameter)
      const dataSourcingRequest = response.data
      const pickIncludedImages = response.included.images || []

      const getImage = (setImage) => {
        let dataImage = null
        const getLastId = Math.max(...setImage.map(val => val.id))
        if (getLastId) {
          dataImage = pickIncludedImages[getLastId].attributes.source
        }
        return dataImage
      }

      const remapDataSourcingRequest = dataSourcingRequest.map((val) => {
        const dataRelationships = val.relationships
        const dataImages = dataRelationships.images
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.title,
          image: dataImages.length > 0 ? getImage(dataImages) :  null,
        }
      })
      
      setSourcingRequestList(remapDataSourcingRequest)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingSourcingRequest(false)
    }
  }, 300)

  useEffect(() => {
    handleGetListUsers()
    // eslint-disable-next-line
  }, [searchUser])

  useEffect(() => {
    handleGetListAgent()
    // eslint-disable-next-line
  }, [searchAgent])

  useEffect(() => {
    handleGetListSales()
    // eslint-disable-next-line
  }, [searchSales])

  useEffect(() => {
    handleGetListOriginCountry()
    // eslint-disable-next-line
  }, [searchOriginCountry])

  useEffect(() => {
    handleGetListDestinationCountry()
    // eslint-disable-next-line
  }, [searchDestinationCountry])

  useEffect(() => {
    handleGetListProduct()
    // eslint-disable-next-line
  }, [searchProduct])

  useEffect(() => {
    handleGetListSupplier()
    // eslint-disable-next-line
  }, [searchSupplier])

  useEffect(() => {
    handleGetListSourcingRequest()
    // eslint-disable-next-line
  }, [searchSourcingRequest])

  useEffect(() => {
    handleGetCurrenciesList()
    if (dataProductQuote) {
      if (dataProductQuote.origin_country_id !== null) {
        handleGetListOriginCountry(dataProductQuote.origin_country_id)
      }
      if (dataProductQuote.destination_country_id !== null) {
        handleGetListDestinationCountry(dataProductQuote.destination_country_id)
      }
      if (dataProductQuote.product_id !== null) {
        handleGetListProduct(dataProductQuote.product_id)
      }
      if (dataProductQuote.product_request_id !== null) {
        handleGetListSourcingRequest(dataProductQuote.product_request_id)
      }
      if (dataProductQuote.user !== null) {
        handleGetListUsers(dataProductQuote.user.id)
      }
      if (dataProductQuote.agent !== null) {
        handleGetListAgent(dataProductQuote.agent.id)
      }
      if (dataProductQuote.supplier_id !== null) {
        handleGetListSupplier(dataProductQuote.supplier_id)
      }
      if (dataProductQuote.sales_by !== null) {
        handleGetListAgent(dataProductQuote.sales_by)
      }
      handleSetForm(dataProductQuote)
    }
    setIsLoaded(true)
    // eslint-disable-next-line
  }, [dataProductQuote])

  const initCKeditor = () => {
    return (
      <CKEditor
        editor={ClassicEditor}
        config={configEditor}
        data={formData.description}
        onReady={(editor) => {
          editor.execute('fontSize', { value: '12px' })
          editor.editing.view.change((writer) => {
            writer.setStyle(
              'height',
              '350px',
              editor.editing.view.document.getRoot()
            )
          })
        }}
        onChange={( event, editor ) => {
          editor.execute('fontSize', { value: '12px' })
          const valueEditor = editor.getData()
          handleChangeForm('description', valueEditor)
        }}
      />
    )
  }

  const handleSetForm = (value) => {
    const dataDetail = {
      id: value.id,
      product_name: value.product_name,
      quote_type: value.quote_type.toUpperCase(),
      original_source_url: value.original_source_url,
      quantity_unit: value.quantity_unit,
      package_type: value.package_type,
      origin_country_id: value.origin_country_id !== null ? `${value.origin_country_id}` : null,
      destination_country_id: value.destination_country_id !== null ? `${value.destination_country_id}` : null,
      product_id: value.product_id !== null ? `${value.product_id}` : null,
      product_request_id: value.product_request_id !== null ? `${value.product_request_id}` : null,
      sales_by: value.sales_by !== null ? `${value.sales_by}` : null,
      user_id: value.user !== null ? `${value.user.id}` : null,
      agent_id: value.agent !== null ? `${value.agent.id}` : null,
      description: value.description === null ? '' : value.description,
      terms: value.terms,
      weight: value.weight,
      volume: value.volume,
      deletedIdVariants: [],
      variants: value.variants,
      supplier_id: value.supplier_id !== null ? `${value.supplier_id}` : null,
      currency: value.variants[0].supplier_currency,
      landed_cost_currency: value.variants[0].landed_cost_currency,
      detail_price: value.detail_price
    }
    setFormData(dataDetail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const handleChangeVariant = (indexVariant, labelName, value) => {
    const formVariant = formData.variants
    const remapForm = formVariant.map((val, index) => {
      if (index === indexVariant) {
        return {
          ...val,
          [labelName]: value
        }
      } else {
        return val
      }
    })
    setFormData((oldVal) => ({ ...oldVal, 'variants': remapForm }))
  }

  const handleUploadImage = (file, indexVariant) => {
    const fileEncoded = file[0]
    const fileReader = new FileReader()
    fileReader.readAsDataURL(fileEncoded)
    fileReader.onload = (reader) => {
      handleChangeVariant(indexVariant, `image`, reader.target.result)
    }
  }

  const handleErrorFile = (file) => {
    const fileState = Object.values(file)
    const errorMessage = fileState[0].errors[0].message
    if (errorMessage) {
      notificationError('Upload Variant Image Error', `${errorMessage}`)
    }
  }

  const handleAddVariant = () => {
    setValidationVariant(variantValidation)

    const payloadAddVariant = {
      request_quote_id: null,
      name: '',
      option: '',
      supplier_price: 0,
      landed_cost_currency: 0,
      supplier_currency: 'IDR',
      description: '',
      weight: 0,
      height: 0,
      width: 0,
      length: 0,
      volume: 0,
      dimension_unit: 'cm',
      bulk_unit: 'crt',
      bulk_qty: 0,
      bulk_qty_per_unit: null,
      qty: 0,
      variant_specification: '',
      image: null,
      recent_variants: []
    }
    
    const variantForm = formData.variants
    variantForm.push(payloadAddVariant)
    setFormData((oldVal) => ({ ...oldVal, 'variants': variantForm }))
    
    setSelectedIndexVariant(`${Number(selectedIndexVariant) + 1}`)
  }

  const assignIdDeleted = (variantForm) => {
    const { recent_variants } = variantForm
    if (recent_variants.length !== 0) {
      const remapIds = recent_variants.map(e => e.id)
      const variantIdsDeleted = [...formData.deletedIdVariants, ...remapIds]

      setFormData((oldVal) => ({ ...oldVal, 'deletedIdVariants': variantIdsDeleted }))
    }
  }

  const handleRemoveVariant = (index) => {
    setValidationVariant(variantValidation)
    const variantForm = [...formData.variants]

    assignIdDeleted(variantForm[index])
    variantForm.splice(index, 1)

    setFormData((oldVal) => ({ ...oldVal, 'variants': variantForm }))
    setSelectedIndexVariant(`${Number(selectedIndexVariant) > 0 ? Number(selectedIndexVariant) - 1 : Number(selectedIndexVariant)}`)
  }

  const onCloseModalForm = () => {
    setSelectedIndexVariant(`0`)
    setFormData(defaultVal)
    setValidationForm(formValidation)
    setValidationVariant(variantValidation)
    onCloseModal()
  }

  const renderUserOption = ({ option, checked }) => {
    return (
      <Group flex="1" align='center' gap="xs">
        <Flex gap='sm' align='center'>
          <Avatar variant='filled' name={option.label} radius="xl" size="sm" color='red' />
          <Box>
            <Text fz={12} fw='600' lineClamp={2}>{option.label}</Text>
            <Text fz={10} fw='500' c='gray.6' lineClamp={2}>{option.email}</Text>
          </Box>
        </Flex>
        {checked && <IconCheck style={{ marginInlineStart: 'auto' }} />}
      </Group>
    )
  }

  const renderProductOption = ({ option }) => {
    return (
      <Group justify='space-between' align='center' gap="xs">
        <Flex gap='sm' align='center'>
          <Paper shadow="sm" w={32} withBorder radius='md'>
            <Image w={30} h={30} radius='md' src={option.image} />
          </Paper>
          <Box>
            <Text fz={10} fw='600' lineClamp={2}>{option.label}</Text>
          </Box>
        </Flex>
      </Group>
    )
  }

  const renderSourcingRequestOption = ({ option }) => {
    return (
      <Group justify='space-between' align='center' gap="xs">
        <Flex gap='sm' align='center'>
          <Paper shadow="sm" w={32} withBorder radius='md'>
            <Image w={30} h={30} radius='md' src={option.image !== null ? option.image : NoImage} />
          </Paper>
          <Box>
            <Text fz={10} fw='600' lineClamp={2}>{option.label}</Text>
          </Box>
        </Flex>
      </Group>
    )
  }

  const loadingDataTemplate = () => {
    return (
      <Box ta='center' my={12}>
        <Loader size={16} />
        <Text c='gray.6' fz={11}>Loading Data</Text>
      </Box>
    )
  }

  const mappingForm = (data) => {

    const mappingTabVariants = (dataVariants) => {
      const remapTabVariant = dataVariants.map((val, index) => {
        return (<Tabs.Tab key={index} value={`${index}`}>Variant {index + 1}</Tabs.Tab>)
      })
      return remapTabVariant
    }

    const mappingPanelVariants = (indexVariant) => {

      const mappingFormBulkVariant = (typePackage) => {
        if (typePackage === 'carton') {
          return (
            <SimpleGrid cols={3} verticalSpacing="sm" mb='sm'>
              <Box>
                <NumberInput
                  label='Bulk Qty'
                  value={formData.variants[Number(selectedIndexVariant)].bulk_qty}
                  onChange={(val) => handleChangeVariant(Number(selectedIndexVariant), `bulk_qty`, val)}
                  rightSection={<Text fz={12} c='black' tt='capitalize'>{formData.variants[Number(selectedIndexVariant)].bulk_unit}</Text>}
                  error={validationVariant.bulk_qty.isError ? `${validationVariant.bulk_qty.message}` : ''}
                  decimalSeparator='.'
                  size='xs'
                  rightSectionWidth={40}
                  withAsterisk
                  />
              </Box>
              <Box>
                <NumberInput
                  label='Bulk Qty Per Unit'          
                  value={formData.variants[Number(selectedIndexVariant)].bulk_qty_per_unit}
                  rightSection={<Text fz={12} c='black' tt='capitalize'>{formData.quantity_unit}</Text>}
                  onChange={(val) => handleChangeVariant(Number(selectedIndexVariant), `bulk_qty_per_unit`, val)}
                  error={validationVariant.bulk_qty_per_unit.isError ? `${validationVariant.bulk_qty_per_unit.message}` : ''}
                  decimalSeparator='.'
                  size='xs'
                  rightSectionWidth={40}
                  withAsterisk
                />
              </Box>
              <Box>
                <Select
                  name='bulk_unit'
                  value={formData.variants[Number(selectedIndexVariant)].bulk_unit}
                  label='Bulk Unit'
                  placeholder='Select bulk unit'
                  data={bulkUnitList}
                  onChange={(val) => handleChangeVariant(Number(selectedIndexVariant), `bulk_unit`, val)}
                  error={validationVariant.bulk_unit.isError ? `${validationVariant.bulk_unit.message}` : ''}
                  size='xs'
                  allowDeselect={false}
                  withAsterisk
                />
              </Box>
            </SimpleGrid>
          )
        }
      }

      const handlingImageVariant = (dataImage) => {
        if (dataImage === null) {
          return (
            <Input.Wrapper label='Variant Image' size='xs'>
              <Box my={1}>
                <Dropzone 
                  accept={[
                    'image/png',
                    'image/jpeg',
                    'image/gif',
                  ]}
                  onDrop={(files) => handleUploadImage(files, Number(selectedIndexVariant))}
                  onReject={(files) => handleErrorFile(files, Number(selectedIndexVariant))}
                  maxSize={2000000}
                >
                  <Center h={40}>
                    <IconPhotoPlus size={24} color='gray' />
                  </Center>
                </Dropzone>
              </Box>
            </Input.Wrapper>
          )
        } else {
          return (
            <Box>
              <Text fz={12} my={5} fw='500'>Variant Image</Text>
              <Center h={70} w='auto' pos='relative'>
                <Paper shadow="xs" p={3} withBorder radius='md'>
                  <Image src={dataImage} w={70} radius='md' h={70} fit='cover' />
                </Paper>
              </Center>
              <Flex justify='center' mt={4}>
                <Button variant='transparent' size='compact-xs' onClick={() => handleChangeVariant(Number(selectedIndexVariant), `image`, null)}>Remove</Button>
              </Flex>
            </Box>
          )
        }
      }

      return (
        <Tabs.Panel value={`${indexVariant}`}>
          <Box my={10}>
            <Box mx='xs' my={10}>
              <Grid justify="flex-start" align="flex-start">
                <Grid.Col span='content'>
                  {handlingImageVariant(formData.variants[Number(selectedIndexVariant)].image)}
                </Grid.Col>
                <Grid.Col span={10}>
                  <SimpleGrid cols={2} verticalSpacing="sm" mb='sm'>
                    <Box>
                      <TextInput
                        name='name'
                        value={formData.variants[Number(selectedIndexVariant)].name}
                        label='Option Name'
                        placeholder='Input option name'
                        error={validationVariant.name.isError ? `${validationVariant.name.message}` : ''}
                        onChange={(val) => handleChangeVariant(Number(selectedIndexVariant), 'name', val.target.value)}
                        withAsterisk
                        size='xs'
                      />
                    </Box>
                    <Box>
                      <TextInput
                        name='option'
                        value={formData.variants[Number(selectedIndexVariant)].option}
                        label='Variant Name'
                        placeholder='Input variant name'
                        error={validationVariant.option.isError ? `${validationVariant.option.message}` : ''}
                        onChange={(val) => handleChangeVariant(Number(selectedIndexVariant), `option`, val.target.value)}
                        withAsterisk
                        size='xs'
                      />
                    </Box>
                    <Box>
                      <NumberInput
                        label='Quantity'
                        value={formData.variants[Number(selectedIndexVariant)].qty}
                        rightSection={<Text fz={12} c='black' tt='capitalize'>{formData.quantity_unit}</Text>}
                        onChange={(val) => handleChangeVariant(Number(selectedIndexVariant), `qty`, val)}
                        error={validationVariant.qty.isError ? `${validationVariant.qty.message}` : ''}
                        decimalSeparator='.'
                        size='xs'
                        rightSectionWidth={formData.quantity_unit !== 'sheets' ? 40 : 60}
                        withAsterisk
                      />
                    </Box>
                    <Box>
                      <NumberInput
                        label={`Price / ${formData.quantity_unit}`}
                        value={formData.variants[Number(selectedIndexVariant)].supplier_price}
                        leftSection={<Text fz={12} c='black' tt='capitalize'>{formData.currency}</Text>}
                        onChange={(val) => handleChangeVariant(Number(selectedIndexVariant), `supplier_price`, val)}
                        error={validationVariant.supplier_price.isError ? `${validationVariant.supplier_price.message}` : ''}
                        thousandSeparator=","
                        size='xs'
                        leftSectionWidth={40}
                        withAsterisk
                      />
                    </Box>
                  </SimpleGrid>
                  <Box mb='sm'>
                    <Textarea
                      name='description'
                      label="Description"
                      placeholder="Input description"
                      value={formData.variants[Number(selectedIndexVariant)].description}
                      onChange={(val) => handleChangeVariant(Number(selectedIndexVariant), `description`, val.target.value)}
                      size='xs'
                      autosize
                      minRows={4}
                      maxRows={4}
                    />
                  </Box>
                  {mappingFormBulkVariant(formData.package_type)}
                  <SimpleGrid cols={2} verticalSpacing="sm" mb='sm'>
                    <Box>
                      <NumberInput
                        label='Weight'
                        value={formData.variants[Number(selectedIndexVariant)].weight}
                        rightSection={<Text fz={12} c='black' tt='capitalize'>Kg</Text>}
                        onChange={(val) => handleChangeVariant(Number(selectedIndexVariant), `weight`, val)}
                        error={validationVariant.weight.isError ? `${validationVariant.weight.message}` : ''}
                        decimalSeparator='.'
                        size='xs'
                        rightSectionWidth={40}
                        withAsterisk
                      />
                    </Box>
                    <Box>
                      <NumberInput
                        label='Height'
                        value={formData.variants[Number(selectedIndexVariant)].height}
                        rightSection={<Text fz={12} c='black' tt='capitalize'>{formData.variants[Number(selectedIndexVariant)].dimension_unit}</Text>}
                        onChange={(val) => handleChangeVariant(Number(selectedIndexVariant), `height`, val)}
                        error={validationVariant.height.isError ? `${validationVariant.height.message}` : ''}
                        decimalSeparator='.'
                        size='xs'
                        rightSectionWidth={40}
                        withAsterisk
                      />
                    </Box>
                    <Box>
                      <NumberInput
                        label='Width'
                        value={formData.variants[Number(selectedIndexVariant)].width}
                        rightSection={<Text fz={12} c='black' tt='capitalize'>{formData.variants[Number(selectedIndexVariant)].dimension_unit}</Text>}
                        onChange={(val) => handleChangeVariant(Number(selectedIndexVariant), `width`, val)}
                        error={validationVariant.width.isError ? `${validationVariant.width.message}` : ''}
                        decimalSeparator='.'
                        size='xs'
                        rightSectionWidth={40}
                        withAsterisk
                      />
                    </Box>
                    <Box>
                      <NumberInput
                        label='Length'
                        value={formData.variants[Number(selectedIndexVariant)].length}
                        rightSection={<Text fz={12} c='black' tt='capitalize'>{formData.variants[Number(selectedIndexVariant)].dimension_unit}</Text>}
                        onChange={(val) => handleChangeVariant(Number(selectedIndexVariant), `length`, val)}
                        error={validationVariant.length.isError ? `${validationVariant.length.message}` : ''}
                        decimalSeparator='.'
                        size='xs'
                        rightSectionWidth={40}
                        withAsterisk
                      />
                    </Box>
                    <Box>
                      <Select
                        name='dimension_unit'
                        value={formData.variants[Number(selectedIndexVariant)].dimension_unit}
                        label='Dimension Unit'
                        placeholder='Select dimension unit'
                        data={dimensionUnit}
                        onChange={(val) => handleChangeVariant(Number(selectedIndexVariant), `dimension_unit`, val)}
                        error={validationVariant.dimension_unit.isError ? `${validationVariant.dimension_unit.message}` : ''}
                        size='xs'
                        allowDeselect={false}
                        withAsterisk
                      />
                    </Box>
                  </SimpleGrid>
                </Grid.Col>
              </Grid>
            </Box>
            <Flex justify='flex-start'>
              <Button size='xs' variant='transparent' leftSection={<IconTrash size={12} />} onClick={() => handleRemoveVariant(indexVariant)} disabled={indexVariant < 1}>Remove This Variant</Button>
            </Flex>
          </Box>
          
        </Tabs.Panel>
      )
    }


    return (
      <Box>
        <Box>
          <Tabs size='xs' my={4} value={selectedTab} onChange={setSelectedTab}>
            <Tabs.List>
              <Tabs.Tab value="form">Product Quote</Tabs.Tab>
              <Tabs.Tab value="variants">Variants</Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel value="form">
              <Box my={10}>
                <SimpleGrid cols={2} verticalSpacing="sm" mb='sm'>
                  <Box>
                    <TextInput
                      name='product_name'
                      value={formData.product_name}
                      label='Product Name'
                      placeholder='Input Product Name'
                      error={validationForm.product_name.isError ? `${validationForm.product_name.message}` : ''}
                      onChange={(val) => handleChangeForm('product_name', val.target.value)}
                      withAsterisk
                      size='xs'
                    />
                  </Box>
                  <Box>
                    <Select
                      name='quote_type'
                      value={formData.quote_type}
                      label='Quote Type'
                      placeholder='Select quote type'
                      data={typeQuoteList}
                      onChange={(val) => handleChangeForm('quote_type', val)}
                      size='xs'
                      allowDeselect={false}
                      withAsterisk
                    />
                  </Box>
                </SimpleGrid>
                <Box mb='sm'>
                  <TextInput
                    name='original_source_url'
                    value={formData.original_source_url}
                    label='Source URL'
                    placeholder='Input source URL'
                    error={validationForm.original_source_url.isError ? `${validationForm.original_source_url.message}` : ''}
                    onChange={(val) => handleChangeForm('original_source_url', val.target.value)}
                    withAsterisk
                    size='xs'
                />
                </Box>
                <SimpleGrid cols={2} verticalSpacing="sm" mb='sm'>
                  <Box>
                    <Select
                      name='currency'
                      value={formData.currency}
                      label='Currency'
                      placeholder='Select currency'
                      data={currencyList}
                      onChange={(val) => handleChangeForm('currency', val)}
                      size='xs'
                      error={validationForm.currency.isError ? `${validationForm.currency.message}` : ''}
                      withAsterisk
                      allowDeselect={false}
                    />
                  </Box>
                  <Box>
                    <Select
                      name='landed_cost_currency'
                      value={formData.landed_cost_currency}
                      label='Landed Cost Currency'
                      placeholder='Select landed cost currency'
                      data={currencyList}
                      onChange={(val) => handleChangeForm('landed_cost_currency', val)}
                      size='xs'
                      error={validationForm.landed_cost_currency.isError ? `${validationForm.landed_cost_currency.message}` : ''}
                      withAsterisk
                      allowDeselect={false}
                    />
                  </Box>
                  <Box>
                    <Select
                      name='quantity_unit'
                      value={formData.quantity_unit}
                      label='Quantity Unit'
                      placeholder='Select quantity unit'
                      data={quantityUnit}
                      onChange={(val) => handleChangeForm('quantity_unit', val)}
                      size='xs'
                      error={validationForm.quantity_unit.isError ? `${validationForm.quantity_unit.message}` : ''}
                      withAsterisk
                      allowDeselect={false}
                    />
                  </Box>
                  <Box>
                    <Select
                      name='package_type'
                      value={formData.package_type}
                      label='Type Package'
                      placeholder='Select type package'
                      data={packageTypeList}
                      onChange={(val) => handleChangeForm('package_type', val)}
                      size='xs'
                      error={validationForm.package_type.isError ? `${validationForm.package_type.message}` : ''}
                      withAsterisk
                      allowDeselect={false}
                    />
                  </Box>
                  <Box>
                    <NumberInput
                      label={`Weight (kg) / ${formData.quantity_unit}`}
                      value={formData.weight}
                      rightSection={<Text fz={12} c='black' tt='capitalize'>Kg</Text>}
                      onChange={(val) => handleChangeForm('weight', val)}
                      error={validationForm.weight.isError ? `${validationForm.weight.message}` : ''}
                      decimalSeparator='.'
                      size='xs'
                      rightSectionWidth={40}
                      withAsterisk
                    />
                  </Box>
                  <Box>
                    <NumberInput
                      label={`Volume (cbm) / ${formData.quantity_unit}`}
                      value={formData.volume}
                      rightSection={<Text fz={12} c='black' tt='capitalize'>CBM</Text>}
                      onChange={(val) => handleChangeForm('volume', val)}
                      error={validationForm.volume.isError ? `${validationForm.volume.message}` : ''}
                      decimalSeparator='.'
                      size='xs'
                      rightSectionWidth={40}
                      withAsterisk
                    />
                  </Box>
                  <Box>
                    <Select
                      name='origin_country_id'
                      value={formData.origin_country_id}
                      label='Origin Country'
                      data={originCountryList}
                      onChange={(val) => handleChangeForm('origin_country_id', val)}
                      error={validationForm.origin_country_id.isError ? `${validationForm.origin_country_id.message}` : ''}
                      size='xs'
                      searchable
                      searchValue={searchOriginCountry}
                      onSearchChange={setSearchOriginCountry}
                      nothingFoundMessage={!loadingOriginCountry ? originCountryList.length > 0 ? '' : 'No Country Found' : loadingDataTemplate()}
                      clearable
                      withAsterisk
                    />
                  </Box>
                  <Box>
                    <Select
                      name='destination_country_id'
                      value={formData.destination_country_id}
                      label='Destination Country'
                      data={destinationCountryList}
                      onChange={(val) => handleChangeForm('destination_country_id', val)}
                      error={validationForm.destination_country_id.isError ? `${validationForm.destination_country_id.message}` : ''}
                      size='xs'
                      searchable
                      searchValue={searchDestinationCountry}
                      onSearchChange={setSearchDestinationCountry}
                      nothingFoundMessage={!loadingDestinationCountry ? destinationCountryList.length > 0 ? '' : 'No Country Found' : loadingDataTemplate()}
                      clearable
                      withAsterisk
                    />
                  </Box>
                  <Box>
                    <Select
                      name='product_id'
                      value={formData.product_id}
                      label='Product Reference'
                      data={productList}
                      onChange={(val) => handleChangeForm('product_id', val)}
                      size='xs'
                      searchable
                      renderOption={renderProductOption}
                      searchValue={searchProduct}
                      onSearchChange={setSearchProduct}
                      nothingFoundMessage={!loadingProduct ? productList.length > 0 ? '' : 'No Product Found' : loadingDataTemplate()}
                      clearable
                    />
                  </Box>
                  <Box>
                    <Select
                      name='supplier_id'
                      value={formData.supplier_id}
                      label='Supplier Information'
                      data={supplierList}
                      onChange={(val) => handleChangeForm('supplier_id', val)}
                      size='xs'
                      searchable
                      searchValue={searchSupplier}
                      onSearchChange={setSearchSupplier}
                      nothingFoundMessage={!loadingSupplier ? supplierList.length > 0 ? '' : 'No Supplier Found' : loadingDataTemplate()}
                      clearable
                    />
                  </Box>
                  <Box>
                    <Select
                      name='user_id'
                      value={formData.user_id}
                      label='User'
                      data={userList}
                      renderOption={renderUserOption}
                      onChange={(val) => handleChangeForm('user_id', val)}
                      error={validationForm.user_id.isError ? `${validationForm.user_id.message}` : ''}
                      size='xs'
                      searchable
                      searchValue={searchUser}
                      onSearchChange={setSearchUser}
                      nothingFoundMessage={!loadingUser ? userList.length > 0 ? '' : 'No User Found' : loadingDataTemplate()}
                      clearable
                      withAsterisk
                    />
                  </Box>
                  <Box>
                    <Select
                      name='product_request_id'
                      value={formData.product_request_id}
                      label='Sourcing Request Ref'
                      data={sourcingRequestList}
                      renderOption={renderSourcingRequestOption}
                      onChange={(val) => handleChangeForm('product_request_id', val)}
                      size='xs'
                      searchable
                      searchValue={searchSourcingRequest}
                      onSearchChange={setSearchSourcingRequest}
                      nothingFoundMessage={!loadingSourcingRequest ? sourcingRequestList.length > 0 ? '' : 'No Sourcing Request Found' : loadingDataTemplate()}
                      clearable
                    />
                  </Box>
                  <Box>
                    <Select
                      name='agent_id'
                      value={formData.agent_id}
                      label='Agent'
                      data={agentList}
                      renderOption={renderUserOption}
                      onChange={(val) => handleChangeForm('agent_id', val)}
                      size='xs'
                      searchable
                      searchValue={searchAgent}
                      onSearchChange={setSearchAgent}
                      nothingFoundMessage={!loadingAgent ? agentList.length > 0 ? '' : 'No Agent Found' : loadingDataTemplate()}
                      clearable
                    />
                  </Box>
                  <Box>
                    <Select
                      name='sales_by'
                      value={formData.sales_by}
                      label='Sales'
                      data={salesList}
                      renderOption={renderUserOption}
                      onChange={(val) => handleChangeForm('sales_by', val)}
                      size='xs'
                      searchable
                      searchValue={searchSales}
                      onSearchChange={setSearchSales}
                      nothingFoundMessage={!loadingSales ? salesList.length > 0 ? '' : 'No Sales Found' : loadingDataTemplate()}
                      clearable
                    />
                  </Box>
                  <Box>
                    <Select
                      name='terms'
                      value={formData.terms}
                      label='Terms'
                      placeholder='Select Terms'
                      data={orderTerms}
                      onChange={(val) => handleChangeForm('terms', val)}
                      error={validationForm.terms.isError ? `${validationForm.terms.message}` : ''}
                      size='xs'
                      allowDeselect={false}
                      withAsterisk
                    />
                  </Box>
                </SimpleGrid>
                <Box mb='md'>
                  <Input.Wrapper 
                    label="Description"
                    size='xs'
                  >
                    {isLoaded ? initCKeditor() : ''}
                  </Input.Wrapper>
                </Box>
              </Box>
            </Tabs.Panel>
            <Tabs.Panel value='variants'>
              <Box my={10}>
                <Flex justify='flex-end' mb='sm'>
                  <Button size='xs' leftSection={<IconPlus size={12} />} onClick={() => handleAddVariant()}>Add Variant</Button>
                </Flex>
                <Box>
                
                  <Tabs variant="pills" size='xs' my={4} value={selectedIndexVariant} onChange={setSelectedIndexVariant}>
                    <ScrollArea maw={width / 2.5} type="auto" offsetScrollbars overscrollBehavior="none" scrollbarSize={5} scrollbars="x">
                      <Tabs.List style={{ width: 'max-content', overflowX: 'hidden'}}>
                        {mappingTabVariants(formData.variants)}
                      </Tabs.List>
                    </ScrollArea>
            
                    <Divider size='sm' my='xs' />
                    {mappingPanelVariants(selectedIndexVariant)}
                  </Tabs>
                </Box>
              </Box>
            </Tabs.Panel>
          </Tabs>
        </Box>
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="outline" onClick={() => onCloseModalForm()}>Close</Button>
              <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitRequestQuote(formData)}>{dataProductQuote !== null ? 'Update' : 'Create'}</Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    )
  }

  return (
    <Box>
      {loadingData ? <LoadingData /> : mappingForm()}
    </Box>
    
  )
}

export default FormProductQuote